// extracted by mini-css-extract-plugin
export default {"bottomBtnWrap":"GgR4Q","bottomBtn":"HQ6jf","aboutLink":"oV6ZV"};